<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
          <a-form-item label="项目名称">
            <a-input v-model="dataForm.goods_name" placeholder="项目名称" allowClear />
          </a-form-item>
          <a-form-model-item label="所属供应商" prop="supplier_id">
            <a-select v-model="dataForm.supplier_id" placeholder="请选择" style="width: 200px" allowClear
              @change="changeSupplier" showSearch :filter-option="filterOption">
              <a-select-option :value="v.supplier_id" v-for="v in supplierList" :key="v.supplier_id">
                {{ v.supplier_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="项目一级分类" prop="categorize_id">
            <a-select v-model="dataForm.categorize_id" placeholder="请选择" style="width: 200px" allowClear>
              <a-select-option :value="v.categorize_id" v-for="v in categorizeList" :key="v.categorize_id">
                {{ v.categorize_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="是否上架小程序" prop="is_app">
            <a-select v-model="dataForm.is_app" placeholder="请选择" style="width: 200px" allowClear>
              <a-select-option value="1">是</a-select-option>
              <a-select-option value="2">否</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="小程序侧边栏分类" prop="navid">
            <a-select v-model="dataForm.navid" placeholder="请选择" style="width: 200px" allowClear>
              <a-select-option :value="v.navid" v-for="v in navList">{{ v.title }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增项目</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id" :loading="dataListLoading"
          :scroll="{ x: 1430 }">
          <template slot="goods_img" slot-scope="goods_img">
            <img v-if="goods_img" :src="goods_img" alt="" width="50px" style="cursor: pointer"
              @click="preview(goods_img)" />
            <a-tag v-else>未上传</a-tag>
          </template>
          <template slot="categorize" slot-scope="text, row">
            <div class="table-avatar-info">
              <div class="avatar-info">
                <h6 class="m-2">{{ row.supplier && row.supplier.supplier_name ? row.supplier.supplier_name : '无供应商信息' }}
                </h6>
                <p class="m-0 font-regular text-muted">
                  分类：{{ row.categorize && row.categorize.categorize_name ? row.categorize.categorize_name : '无分类信息' }}
                </p>
              </div>
            </div>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.goods_id)">
              编辑
            </a-button>
            <!-- <a-button
              type="link"
              class="btn-edit"
              @click="deleteHandle(row.supplier_id)"
            >
              删除
            </a-button> -->
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/suppliergoods/page",
        deleteURL: "/admin/role/delete",
      },
      dataForm: {
        goods_name: "",
        supplier_id: undefined,
        categorize_id: undefined,
        is_app: undefined
      },
      columns: [
        {
          title: "项目名称",
          dataIndex: "goods_name",
          width: 250,
          ellipsis: true,
        },
        {
          title: "小程序项目名称",
          dataIndex: "goods_appname",
          width: 250,
          ellipsis: true,
        },
        {
          title: "供应商分类",
          dataIndex: "categorize",
          scopedSlots: { customRender: "categorize" },
          width: 300,
        },
        {
          title: "项目图片",
          dataIndex: "goods_img",
          scopedSlots: { customRender: "goods_img" },
          width: 100,
        },
        {
          title: "项目售价",
          dataIndex: "goods_price",
          width: 100,
        },
        {
          title: "排序",
          dataIndex: "goods_sort",
          width: 80,
        },
        {
          title: "项目备注",
          dataIndex: "remark",
          width: 200,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180,
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
      supplierList: [],
      categorizeList: [],
      navList: []
    };
  },
  created() {
    this.getSupplierList();
    this.getNavList()
  },
  methods: {
    getNavList() {
      this.$http({
        url: "/admin/appnav/page?page=1&limit=500",
        method: "get",
      }).then((res) => {
        this.navList = res.data.result;
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getSupplierList() {
      this.$http({
        url: "/admin/supplier/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.supplierList = res.data.result;
      });
    },
    preview(url) {
      this.$viewerApi({
        images: [url],
      });
    },
    changeSupplier(e) {
      console.log(e);
      this.dataForm.categorize_id = undefined;
      this.$http({
        url: "/admin/suppliercategorize/page?page=1&limit=200&supplier_id=" + e,
        method: "get",
      }).then((res) => {
        this.categorizeList = res.data.result;
      });
    },
  },
};
</script>